import { Preference, Value } from './../../model/preference';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreferenceMessages } from '../../../../shared/models/component-messages/preference-messages';
import { PreferencesService } from '../../services/preferences.service';

@Component({
  selector: 'app-modal-diffuseur',
  templateUrl: './modal-diffuseur.component.html',
  styleUrls: ['./modal-diffuseur.component.scss']
})
export class ModalDiffuseurComponent implements OnInit, OnDestroy {

  @Input() diffuseurIds: Array<number>;

  public preferenceMessages = new PreferenceMessages();

  public form: FormGroup;

  private unsubscribe$ = new Subject<void>();

  constructor(private preferenceService: PreferencesService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.form = new FormGroup({});
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  valider() {
    const preference: Preference = new Preference();
    preference.titre = this.form.get("intitule")?.value;
    this.diffuseurIds.forEach(id => {
      const value: Value = new Value();
      value.code = "idDiffuseur";
      value.value = String(id);
      preference.content.values.push(value)
    })
    this.preferenceService.createDiffuseur(preference).pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.exitModal();
        })
      });
  }

  exitModal() {
    this.modalService.dismissAll();
  }

}
